import { useState } from "react";
import { downloadAuthenticatedExport } from "@/lib/downloadExport";

export default function ExportDownloadButton({
  url,
  defaultFilename,
  className,
  children,
  testId,
}) {
  const [busy, setBusy] = useState(false);

  const onClick = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await downloadAuthenticatedExport(url, defaultFilename);
    } catch (e) {
      alert(e.message || "Download failed. Try signing in again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={busy}
      className={className}
      data-testid={testId}
    >
      {busy ? "Downloading…" : children}
    </button>
  );
}
